import React from 'react';
import {
  IconDataflow,
  IconTerminal,
  IconShieldTick,
  IconBankNote,
  IconAdd,
  IconAiPencil,
  IconStarMoving,
  IconDashboard,
  IconMail,
  IconMenu,
  IconSites,
  IconSupport,
  IconTools,
  IconN8N,
  IconRobot,
  IconClock,
  IconChatCheck,
  IconMegaphone,
  IconBag,
  IconOpenClaw,
  IconStarsBright,
  IconClockCheck,
  IconPaint,
  IconPlayer,
  IconBlogRight,
  IconQuestion,
} from 'gatorcomponents';
import VpsN8nImage from '@/pages/Home/media/vps-n8n.png';
import VpsOpenClawImage from '@/pages/Home/media/vps-open-claw.png';
import WordPressAIImage from '@/pages/Home/media/wordpress-ai-es.png';
import SiteBuilderV2Image from '@/pages/Home/media/site-builder-v2-es.png';
import EmailTitanImage from '@/pages/Home/media/email-titan.png';
import AiAgentsImage from '@/pages/Home/media/ai-agents.png';
import { PRODUCTS_HIGHLIGHT_IDS } from '../../pages/Home/HomeHandler.enum';
import { COUNTRY, SITE_HG } from '@/config';
import { formatCurrency } from '@/utils/Formatters/formatCurrency';
import { OPTIONS } from '@/components/Layout/Menu/HeaderV2/components/NewAiHeaderButton/NewAiHeaderButton.types';
import { SERVICES_IDS } from '@/pages/Home/components/Services/Services.enum';
import { ESSENTIAL_TOOLS_IDS } from '@/pages/Home/components/EssentialTools/EssentialTools.enum';
import { PRODUCTS_OFFER_IDS } from '@/pages/Home/components/ProductsOffer/ProductsOffer.enum';

const n8nPrices = {
  mx: 62.00,
  co: 14250.00,
  cl: 3490.00,
  ar: 3239.49,
  pe: 14.49,
  do: 214.19,
  ec: 3.99,
  uy: 142.99,
  bo: 24.99,
};
const priceSymbols = {
  mx: 'MX$',
  co: 'COP$',
  cl: 'CLP$',
  ar: 'AR$',
  pe: 'S/',
  do: 'RD$',
  ec: 'US$',
  uy: 'UYU$',
  bo: 'Bs',
};
const n8nPrice = n8nPrices[COUNTRY.toLowerCase()];
const priceSymbolText = priceSymbols[COUNTRY.toLowerCase()];

export default {
  aiConversationBanner: {
    betaTag: 'Beta',
    title: (name = '') => `Hola, ${name}. ¡Dime qué quieres hacer!`,
    input: {
      placeholderAlreadyOpened: 'Ya tienes un chat abierto con el Gator',
      placeholder: 'Pregunta o pídele al Gator que haga algo...',
    },
    audio: {
      recordingLabel: 'Escuchando...',
      transcribingLabel: 'Generando Transcripción...',
    },
    suggestions: [
      {
        Icon: IconDashboard,
        id: 'create-site',
        label: 'Crear sitio',
        initialMessage: 'Ayúdame a crear un nuevo sitio web',
        action: 'newSite',
        value: OPTIONS.CREATE_SITE,
      },
      {
        Icon: IconMail,
        id: 'create-email',
        label: 'Crear correo',
        initialMessage: 'Ayúdame a crear un correo profesional',
        action: 'email',
        value: OPTIONS.CREATE_EMAIL,
      },
      {
        Icon: IconAdd,
        id: 'contract-domain',
        label: 'Contratar dominio',
        initialMessage: 'Quiero contratar un dominio',
        value: OPTIONS.DOMAIN_PURCHASE,
      },
      {
        Icon: IconStarMoving,
        id: 'marketing-tips',
        label: 'Marketing',
        initialMessage: 'Enumera las formas en las que puedes ayudarme con marketing',
        value: OPTIONS.MARKETING_TIPS,
        hidden: true,
      },
      {
        Icon: IconSupport,
        id: 'support',
        label: 'Soporte',
        initialMessage: 'Necesito apoyo',
        value: OPTIONS.SUPPORT,
      },
      {
        Icon: IconMenu,
        id: 'more',
        label: 'Más',
        action: 'expand',
        value: OPTIONS.MORE,
      },
      {
        Icon: IconSites,
        hideOnInit: true,
        id: 'configure-domain',
        label: 'Configurar dominio (DNS)',
        initialMessage: 'Configura mi dominio',
        action: 'domainConfig',
        value: OPTIONS.CONFIGURE_DOMAIN,
      },
      {
        Icon: IconTools,
        hideOnInit: true,
        id: 'check-account',
        label: 'Revisar mi cuenta',
        initialMessage: 'Haz un diagnóstico de mi cuenta',
        value: OPTIONS.CHECK_ACCOUNT,
      },
      {
        Icon: IconAiPencil,
        hideOnInit: true,
        id: 'create-posts',
        label: 'Crear publicaciones',
        initialMessage: 'Ayúdame a crear mensajes para publicaciones en redes sociales',
        value: OPTIONS.CREATE_POSTS,
        hidden: true,
      },
      {
        Icon: IconBag,
        hideOnInit: true,
        id: 'contract-product',
        label: 'Contratar producto',
        initialMessage: 'Quiero contratar un nuevo producto',
      },
    ],
  },
  greetingBanner: {
    title: (name = '') => (
      <>
        ¡Hola,
        {' '}
        <strong>{name}</strong>
        !
      </>
    ),
    subtitle: '¡Qué bueno tenerte por aquí!',
    cta: {
      label: 'Crear sitio web',
      link: '/sitios-web/crear-sitio-web',
    },
  },
  bannerAiAgent: {
    popover: {
      title: 'Soy una Inteligencia Artificial',
      description: 'Hago que tu sitio web esté listo en un momento. ¿Quieres ver lo fácil que es?',
      buttonLabel: 'Entendí',
    },
  },
  VinculedGoogle: {
    title: '¡Éxito al vincular tu cuenta con Google!',
    message: 'Ahora puedes iniciar sesión con tu usuario y contraseña o directamente a través de Google',
  },
  ContractedProducts: {
    hosting: {
      title: 'Hosting',
      buttonGoToLabel: 'Ir a Hosting',
      empty: {
        title: '¡Hospede su sitio con calidad y conquiste el mundo digital!',
        subtitle: 'Elija un alojamiento confiable y lleve su negocio al siguiente nivel.',
        buttonLabel: 'Contratar hosting',
      },
    },
    domain: {
      title: 'Dominios',
      buttonGoToLabel: 'Ir al dominio',
      empty: {
        title: '¡Asegure su dominio ahora y destaque su marca online!',
        subtitle: 'Registre su dominio ahora y lleve su negocio al siguiente nivel.',
        buttonLabel: 'Contratar dominio',
      },
    },
    buttonLabelManage: 'Administrar',
    expiresOn: 'Expira en',
    hostingStatus: {
      pending: 'Pendiente',
      active: 'Activo',
      completed: 'Completo',
      suspended: 'Suspendido',
      terminated: 'Cerrado',
      cancelled: 'Cerrado',
      fraud: 'Fraude',
      building: 'En Configuración',
      activationPending: 'Esperando activación',
    },
  },
  infosMenuHighlight: {
    tagNew: 'Nuevo',
    studioGuide: {
      title: 'Conozca HostGator Studio',
      description: 'Aproveche la funcionalidad de Studio para crear contenidos gratis para su negocio.',
    },
    staticHighlights: [
      {
        id: PRODUCTS_HIGHLIGHT_IDS.HG_BUILDER,
        size: 100,
        name: 'HostGator Builder',
        title: 'Creador de sitios',
        subtitle: 'Llegó el nuevo Creador de sitios con IA',
        description: 'Sin códigos. Sin complicaciones. Solo resultados. Tú hablas, la IA lo crea. ¿Tu negocio online? ¡Solo aquí!',
        link: '/sitios-web/crear-sitio-web',
        image: SiteBuilderV2Image,
        cta: 'Quiero mi sitio',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Crear sitio Web',
          icon: <IconDashboard color="primaryExtraDark" />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.SITE_CREATOR,
        size: 100,
        name: 'HighLightProduct',
        title: 'WordPress',
        subtitle: '¡Tenga un sitio listo para vender más!',
        description: 'Nuestro WordPress con IA lo hace todo por usted: textos, imágenes, diseño, ¡sin complicaciones! Solo necesita modificarlo si lo desea.',
        link: '/sitios-web/crear-sitio-web',
        image: WordPressAIImage,
        cta: 'Quiero mi sitio',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Crear sitio web',
          icon: <IconDashboard color="primaryExtraDark" />,
        },
      },
      {
        id: PRODUCTS_HIGHLIGHT_IDS.EMAIL_TITAN,
        size: 100,
        name: 'HighLightProduct',
        title: 'Correo Titan',
        subtitle: '¡Ten un correo con el nombre de tu marca!',
        description: 'Gana la confianza de tus clientes. Crea cuentas para cada equipo y agenda reuniones con calendario.',
        tag_color: '#FFCF00',
        link: 'open_merlin',
        image: EmailTitanImage,
        cta: 'Crear correo',
        link_open_behavior: 'function',
        menu: {
          title: 'Correo Profesional',
          icon: <IconMail color="primaryExtraDark" />,
        },
      },
      {
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.AI_AGENTS,
        size: 100,
        name: 'Agentes de IA',
        subtitle: 'Sólo en Creador de Sitios: ¡aprovecha ahora!',
        title: 'Ten un agente de IA que atienda por ti',
        badge: 'Gratis en tu plan',
        image: AiAgentsImage,
        cta: 'Quiero mi agente',
        descriptionList: [
          {
            icon: <IconChatCheck color="lowPure" />,
            text: 'Responder dudas en segundos;',
            id: 'reply',
          },
          {
            icon: <IconMegaphone color="lowPure" />,
            text: 'Presentar tus productos y servicios;',
            id: 'show_products',
          },
          {
            icon: <IconClock color="lowPure" />,
            text: 'Servicio 24 horas',
            id: '24_hours_support',
          },
        ],
        menu: {
          title: 'Crea tu Agente de IA',
          icon: <IconRobot color="primaryExtraDark" />,
        },
        flag_new: 1,
      },
      {
        // Note: This object id is not returned by the API
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.VPS_N8N,
        size: 100,
        name: 'HighLightProduct',
        title: 'Servidor VPS n8n',
        description: 'Crea y ejecuta tus automatizaciones en minutos',
        descriptionPrefix: (price = n8nPrice) => `desde ${formatCurrency(price)}/mes`,
        descriptionList: [
          {
            icon: <IconDataflow color="lowPure" />,
            text: 'Flujos de trabajo e integraciones ilimitadas',
            id: 'dataflow',
          },
          {
            icon: <IconTerminal color="lowPure" />,
            text: 'Acceso root y libertad total para personalizar',
            id: 'terminal',
          },
          {
            icon: <IconShieldTick color="lowPure" />,
            text: 'Entorno aislado y confiable',
            id: 'shield',
          },
          {
            icon: <IconBankNote color="lowPure" />,
            text: 'Sin cobros por tareas ni límites de uso',
            id: 'banknote',
          },
        ],
        link: '/sitios-web/crear-sitio-web',
        image: VpsN8nImage,
        cta: 'Conocer VPS n8n',
        link_open_behavior: 'same_tab',
        menu: {
          title: 'Servidor VPS n8n',
          icon: <IconN8N color="primaryExtraDark" />,
        },
      },
      {
        // Note: This object id is not returned by the API
        forceShow: true,
        id: PRODUCTS_HIGHLIGHT_IDS.VPS_OPEN_CLAW,
        size: 100,
        name: 'HighLightProduct',
        title: 'Servidor VPS OpenClaw',
        subtitle: (
          <>
            Coloca un
            {' '}
            <span>agente de IA</span>
            {' '}
            para actuar por ti
          </>
        ),
        description: 'Automatiza tareas, integra plataformas y reduce el trabajo manual. El OpenClaw ejecuta procesos de forma autónoma y trabaja continuamente para ti en tu día a día.',
        link: `${SITE_HG}/vps-hosting/openclaw`,
        image: VpsOpenClawImage,
        cta: 'Conocer VPS OpenClaw',
        link_open_behavior: 'new_tab',
        menu: {
          title: 'Servidor VPS OpenClaw',
          icon: <IconOpenClaw color="primaryExtraDark" />,
        },
        flag_new: 1,
      },
    ],
  },
  infosLoadingError: {
    buttonLabel: 'Recargar Página',
    message: (
      <>
        Ocurrió un error al cargar la página
        {' '}
        <br />
        Si persiste, intente nuevamente más tarde.
      </>
    ),
  },
  v2: {
    banner: {
      listTitle: 'Tu sitio creado con IA',
      list: [
        { text: 'En minutos, el sitio de tu negocio listo, hoy', icon: <IconClockCheck color="primaryExtraDark" /> },
        { text: 'Di cómo lo quieres y nuestra IA lo hace todo', icon: <IconStarsBright color="primaryExtraDark" /> },
        { text: 'Tu sitio con colores, diseño, textos y mucho más', icon: <IconPaint color="primaryExtraDark" /> },
      ],
      cta: 'Crear sitio con IA',
    },
    freeDomainCard: {
      titlePrefix: 'Garantiza ya tu dominio ',
      titleBold: 'gratis',
      description: 'Busca el nombre de tu marca y ten tu presencia digital.',
      search: {
        placeholder: 'Buscar dominio',
        cta: 'Buscar dominio',
      },
      links: {
        prefix: '¿Ya tienes un dominio?',
        separator: 'o',
        transfer: {
          label: 'Cómo transferir a HostGator',
          link: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217312747',
        },
        configure: {
          label: 'Configura tu dominio',
          link: 'https://soporte-latam.hostgator.com/hc/es-419/articles/217236957',
        },
      },
    },
    usefulLinks: {
      title: '¡Mantente al día!',
      cards: [
        {
          id: 'courses',
          icon: <IconPlayer color="primaryBlue" />,
          title: 'Cursos gratuitos con certificados',
          description: 'Aprende con especialistas a transformar tu negocio en presencia digital.',
          cta: 'Acceder',
        },
        {
          id: 'blog',
          icon: <IconBlogRight color="primaryBlue" />,
          title: 'HostGator Blog',
          description: 'Consejos, instrucciones e tutoriales imperdibles.',
          cta: 'Acceder',
        },
        {
          id: 'help',
          icon: <IconQuestion color="primaryBlue" />,
          title: 'Centro de ayuda',
          description: '¿Tienes alguna duda? ¡Nosotros te ayudamos!',
          cta: 'Acceder',
        },
      ],
    },
    services: {
      title: 'Tenemos todo lo que necesitas para acelerar tu negocio:',
      cards: {
        [SERVICES_IDS.HOSTING]: {
          id: SERVICES_IDS.HOSTING,
          alt: 'Tenga un hosting para crear su primer sitio web',
        },
        [SERVICES_IDS.GATOR_PROTECT]: {
          id: SERVICES_IDS.GATOR_PROTECT,
          alt: 'Protección automática contra amenazas en su sitio web',
        },
        [SERVICES_IDS.OPEN_CLAW]: {
          id: SERVICES_IDS.OPEN_CLAW,
          alt: 'Ejecuta agentes de IA de alta performance con OpenClaw ',
        },
        [SERVICES_IDS.EMAIL]: {
          id: SERVICES_IDS.EMAIL,
          alt: 'Crea un correo con el nombre de tu marca.',
          showTag: true,
          tag: 'Gratis 30 días',
        },
      },
    },
    modalRegisterDomain: {
      title: 'Registra un dominio para continuar',
      description: (
        <>
          El dominio es necesario para habilitar el uso de este producto.
          <br />
          Registra el dominio y continúa con la activación.
        </>
      ),
      buttonCancel: 'Cancelar',
      buttonRegister: 'Registrar dominio',
    },
    essentialTools: {
      title: 'Tu proyecto ya está listo. Activa ahora los siguientes pasos.',
      subtitle: 'Preconfiguramos las herramientas esenciales para que empieces más rápido.',
      cards: {
        [ESSENTIAL_TOOLS_IDS.EMAIL]: {
          id: ESSENTIAL_TOOLS_IDS.EMAIL,
          title: 'Correo profesional',
          description: 'El 75% de los clientes confía más en empresas con correo profesional.',
          tag: {
            label: 'Créalo en 2 minutos',
            variant: 'info',
          },
          cta: {
            primary: 'Crear correo profesional',
            secondary: 'Acceder a mi correo',
          },
        },
        [ESSENTIAL_TOOLS_IDS.LINK_IN_BIO]: {
          id: ESSENTIAL_TOOLS_IDS.LINK_IN_BIO,
          title: 'Link en la bio',
          description: 'Los perfiles con link en la bio generan hasta un 40% más de clics a tus canales.',
          tag: {
            label: 'Gratis',
          },
          cta: {
            primary: 'Crear link en la bio gratis',
            secondary: 'Acceder a mi link en la bio',
          },
        },
        [ESSENTIAL_TOOLS_IDS.GATOR_PROTECT]: {
          id: ESSENTIAL_TOOLS_IDS.GATOR_PROTECT,
          title: 'Protege tu sitio',
          description: 'Los ataques a sitios ocurren cada 39 segundos en internet. Protege tu sitio',
          cta: {
            primary: 'Acceder a Gator Protect PRO',
            secondary: 'Activar Gator Protect PRO',
            tertiary: 'Probar PRO gratis por 30 días',
          },
        },
        [ESSENTIAL_TOOLS_IDS.DOMAIN]: {
          id: ESSENTIAL_TOOLS_IDS.DOMAIN,
          title: 'Dominios',
          description: 'El 84% de los consumidores confía más en marcas con sitio y dominio propio.',
          cta: {
            primary: 'Comprar nuevo dominio',
            secondary: 'Acceder a mi dominio',
          },
        },
        [ESSENTIAL_TOOLS_IDS.SITE_BUILDER]: {
          id: ESSENTIAL_TOOLS_IDS.SITE_BUILDER,
          title: 'Crear sitio',
          description: 'El 81% de los clientes investiga en internet antes de comprar.',
          tag: {
            label: 'Gratis',
          },
          cta: {
            primary: 'Crear nuevo sitio',
            secondary: 'Acceder a mis sitios',
          },
        },
        [ESSENTIAL_TOOLS_IDS.SITE_LOCK]: {
          id: ESSENTIAL_TOOLS_IDS.SITE_LOCK,
          title: 'SiteLock',
          description: 'La verificación de SiteLock identifica vulnerabilidades, amenazas y protege tu sitio.',
          cta: {
            primary: 'Acceder a SiteLock',
            secondary: 'Acceder a SiteLock',
          },
        },
      },
    },
    productsOffer: {
      title: 'Potencia lo que ya tienes. Tenemos más soluciones para tu negocio:',
      description: 'Cada producto aquí aumenta la fortaleza de tu empresa: más rendimiento, más seguridad, más alcance. Habla con nosotros',
      pricesText: {
        pricePrefix: 'Desde',
        priceSuffix: (text = priceSymbolText) => `${text} /mes*`,
        priceSymbol: '$',
        discount: value => `${value} % de desconto`,
      },
      cta: 'Aprovecha la oferta',
      products: {
        [PRODUCTS_OFFER_IDS.VPS_OPEN_CLAW]: {
          id: PRODUCTS_OFFER_IDS.VPS_OPEN_CLAW,
          name: 'VPS OpenClaw',
          description: 'Ejecuta agentes de IA OpenClaw con seguridad y alto rendimiento.',
        },
        [PRODUCTS_OFFER_IDS.VPS_N8N]: {
          id: PRODUCTS_OFFER_IDS.VPS_N8N,
          name: 'VPS n8n',
          description: 'Crea flujos potentes para escalar tu negocio con el máximo rendimiento.',
        },
        [PRODUCTS_OFFER_IDS.DEDICATED_LINUX_SERVER]: {
          id: PRODUCTS_OFFER_IDS.DEDICATED_LINUX_SERVER,
          name: 'Servidor Dedicado Linux',
          description: 'El mejor rendimiento con la menor latencia del mercado.',
        },
      },
    },
  },
};
